export default __webpack_public_path__ + "static/double-0bf3f5b7314fa53110977ee8d357f7ec.jpg";